import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from '../azure-auth';
import { collection, getDocs, doc, setDoc, deleteDoc, updateDoc } from 'firebase/firestore';
import { FaUserPlus, FaEdit, FaTrash, FaUsers, FaSignOutAlt, FaArrowLeft, FaUser } from 'react-icons/fa';
import './AdminDashboard.css';

import '../uiux.css'; 
import Footer from './Footer';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ 
    email: '', 
    firstName: '', 
    lastName: '', 
    role: 'user' 
  });
  const [editingUser, setEditingUser] = useState(null);
  const [editingUserData, setEditingUserData] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });
  const [showAddUserPopup, setShowAddUserPopup] = useState(false);
  const [showUserManagementPopup, setShowUserManagementPopup]= useState(false);

  const toggleAddUserPopup = () => {
    setShowAddUserPopup(prevState => !prevState);
  };

  const toggleUserManagementPopup = () => {
    setShowUserManagementPopup(prevState => !prevState);
  };

  useEffect(() => {
    loadUsers();
  }, []);

const loadUsers = async () => {
  setLoading(true);
  try {
    const response = await fetch('https://aisleaiagents.sltdigitallab.lk/api/admin/users'); 
    const data = await response.json();
    
    const usersList = data.users || data;  

    const sortedUsers = usersList.sort((a, b) => {
      const aName = `${a.firstName || ''} ${a.lastName || ''}`.trim();
      const bName = `${b.firstName || ''} ${b.lastName || ''}`.trim();
      return aName.localeCompare(bName);
    });
    
    setUsers(sortedUsers);
  } catch (error) {
    console.error('Error loading users:', error);
    setMessage({ text: 'Error loading users', type: 'error' });
  } finally {
    setLoading(false);
  }
};



const roleOptions = [
  { value: 'user', label: 'Standard User' },
  { value: 'A', label: 'Test Aisle Web User' },
  { value: 'B', label: 'ASK HR User' },
  { value: 'C', label: 'Digital Lab User' },
  { value: 'D', label: 'Embryo User' },
  { value: 'E', label: 'Sales Assistant User' },
  { value: 'F', label: 'Full Access User' },
  { value: 'G', label: 'SLTMNIT User' },
  { value: 'admin', label: 'Administrator' },
];


  const showMessage = (text, type) => {
    setMessage({ text, type });
    setTimeout(() => setMessage({ text: '', type: '' }), 5000);
  };

  const validateUserData = (userData) => {
    const errors = [];
    
    if (!userData.email) {
      errors.push('Email is required');
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(userData.email)) {
        errors.push('Please enter a valid email address');
      }
    }
    
    if (!userData.firstName) {
      errors.push('First name is required');
    } else if (userData.firstName.length < 2) {
      errors.push('First name must be at least 2 characters long');
    }
    
    if (!userData.lastName) {
      errors.push('Last name is required');
    } else if (userData.lastName.length < 2) {
      errors.push('Last name must be at least 2 characters long');
    }
    
    if (!userData.role) {
      errors.push('Role is required');
    }
    
    return errors;
  };

  const addUser = async () => {
    const errors = validateUserData(newUser);
    if (errors.length > 0) {
      showMessage(errors.join(', '), 'error');
      return;
    }

    // Check if user already exists
    if (users.some(user => user.email.toLowerCase() === newUser.email.toLowerCase())) {
      showMessage('User with this email already exists', 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch('https://aisleaiagents.sltdigitallab.lk/api/admin/users', {  // http://localhost:5000/api/admin/users
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newUser),
      });
      
      if (response.ok) {
        loadUsers(); // Reload users from server
        setNewUser({ email: '', firstName: '', lastName: '', role: 'user' });
        setShowAddUserPopup(false);
        showMessage(`User ${newUser.firstName} ${newUser.lastName} added successfully`, 'success');
      } else {
        const errorData = await response.json();
        showMessage(errorData.error || 'Error adding user', 'error');
      }
    } catch (error) {
      console.error('Error adding user:', error);
      showMessage('Error adding user. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const updateUser = async (userEmail, updatedData) => {
    const errors = validateUserData({ ...updatedData, email: userEmail });
    if (errors.length > 0) {
      showMessage(errors.join(', '), 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`https://aisleaiagents.sltdigitallab.lk/api/admin/users/${userEmail}`, {  // http://localhost:5000/api/admin/users/${userEmail}
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedData),
      });
      
      if (response.ok) {
        loadUsers(); // Reload users from server
        setEditingUser(null);
        setEditingUserData({});
        showMessage(`User ${updatedData.firstName} ${updatedData.lastName} updated successfully`, 'success');
      } else {
        const errorData = await response.json();
        showMessage(errorData.error || 'Error updating user', 'error');
      }
    } catch (error) {
      console.error('Error updating user:', error);
      showMessage('Error updating user. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  };

    const deleteUser = async (userEmail) => {
      const user = users.find(u => u.email === userEmail);
      const userName = user ? `${user.firstName} ${user.lastName}` : userEmail;
      
      if (!window.confirm(`Are you sure you want to delete user "${userName}"? This action cannot be undone.`)) {
        return;
      }
      
      setLoading(true);
      try {
        const response = await fetch(`https://aisleaiagents.sltdigitallab.lk/api/admin/users/${userEmail}`, {  // http://localhost:5000/api/admin/users/${userEmail}
          method: 'DELETE',
        });
        
        if (response.ok) {
          loadUsers(); // Reload users from server
          showMessage(`User ${userName} deleted successfully`, 'success');
        } else {
          const errorData = await response.json();
          showMessage(errorData.error || 'Error deleting user', 'error');
        }
      } catch (error) {
        console.error('Error deleting user:', error);
        showMessage('Error deleting user. Please try again.', 'error');
      } finally {
        setLoading(false);
      }
    };

  const startEditUser = (user) => {
    setEditingUser(user.email);
    setEditingUserData({
      firstName: user.firstName || '',
      lastName: user.lastName || '',
      role: user.role
    });
  };

  const handleEditInputChange = (field, value) => {
    setEditingUserData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const saveUserEdit = (userEmail) => {
    updateUser(userEmail, editingUserData);
  };

  const cancelEdit = () => {
    setEditingUser(null);
    setEditingUserData({});
  };

  const getRoleLabel = (roleValue) => {
    const role = roleOptions.find(r => r.value === roleValue);
    return role ? role.label : roleValue;
  };

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      try {
        await signOut();
      } catch (error) {
        console.error('Logout error:', error);
      }
    }
  };
  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  const getUserDisplayName = (user) => {
    if (user.firstName && user.lastName) {
      return `${user.firstName} ${user.lastName}`;
    } else if (user.firstName) {
      return user.firstName;
    } else if (user.lastName) {
      return user.lastName;
    }
    return 'N/A';
  };

  const getUserStats = () => {
    const roleStats = {};
    users.forEach(user => {
      roleStats[user.role] = (roleStats[user.role] || 0) + 1;
    });
    return roleStats;
  };

  const userStats = getUserStats();

  return (
    <div className="admin-dashboard-page">
      {/* Fixed Logos */}
      <img 
        src="/aisleaiagents.png" 
        alt="aisleaiagents Logo" 
        className="logo" 
        onClick={() => navigate('/dashboard')} 
        style={{ cursor: 'pointer',position: 'absolute', top: '10px', left: '10px' }}  
      />      
      <img src="/embryo-removebg.png" alt="Embryo Logo" className="logo2" style={{ cursor: 'pointer',position: 'absolute', top: '10px', right: '10px' }}  />

      
      <div className="admin-dashboard-container">
        {/* Header */}
        <div className="admin-header">
          <div className="admin-header-left">
            <button
              onClick={handleBackToDashboard}
              className="back-button"
            >
              <FaArrowLeft />
              Back to Dashboard
            </button>
            <div className='AdminHeaderText'>
              <h1 className="admin-title">
                <FaUsers className="admin-icon" />
                Admin Dashboard
              </h1>
              <p className="admin-subtitle">
                Manage user roles and permissions • {users.length} total users
              </p>
            </div>
          </div>
          
          <button className="Btn" onClick={handleLogout}>
            <div className="sign">
              <svg viewBox="0 0 512 512">
                <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"></path>
              </svg>
            </div>
            <div className="text">Logout</div>
          </button>
        </div>

        {/* Message Display */}
        {message.text && (
          <div className={`message ${message.type}`}>
            {message.text}
          </div>
        )}

        {/* Add New User Button */}
        <div className="new-user">
          <button className="new-user-button" onClick={toggleAddUserPopup}>
            <FaUserPlus className="new-user-icon" />
            Add New User
          </button>
        </div>


        {/* Add User Popup */}
        {showAddUserPopup && (
          <div className="popup-overlay">
            <div className="popup-content">
              <button className="popup-close-button" onClick={toggleAddUserPopup}>
                ✕
              </button>
              <div className="admin-form-section">
                <h2 className="section-title">
                  <FaUserPlus className="section-icon" />
                  Add New User
                </h2>
                <div className="add-user-form">
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      value={newUser.email}
                      onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                      placeholder="user@example.com"
                      className="admin-input"
                      disabled={loading}
                    />
                  </div>
                  <div className="form-group">
                    <label>First Name *</label>
                    <input
                      type="text"
                      value={newUser.firstName}
                      onChange={(e) => setNewUser({ ...newUser, firstName: e.target.value })}
                      placeholder="Sahan"
                      className="admin-input"
                      disabled={loading}
                    />
                  </div>
                  <div className="form-group">
                    <label>Last Name *</label>
                    <input
                      type="text"
                      value={newUser.lastName}
                      onChange={(e) => setNewUser({ ...newUser, lastName: e.target.value })}
                      placeholder="Silva"
                      className="admin-input"
                      disabled={loading}
                    />
                  </div>
                  <div className="form-group">
                    <label>Role *</label>
                    <select
                      value={newUser.role}
                      onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
                      className="admin-select"
                      disabled={loading}
                    >
                      <option value="">Select a role</option>
                      {roleOptions.map(role => (
                        <option key={role.value} value={role.value}>
                          {role.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <button
                    onClick={addUser}
                    disabled={loading}
                    className="add-user-button"
                  >
                    <FaUserPlus />
                    {loading ? 'Adding...' : 'Add User'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        
        {/* User Management Box */}
        <div className="user-management-box" onClick={toggleUserManagementPopup}>
          <h3>
            <FaUser className="user-icon" />
            User Management ({users.length} total users)
          </h3>
        </div>

        {/* User Management Popup */}
        {showUserManagementPopup && (
          <div className="popup-overlay-management">
            <div className="popup-content-management">
              <button className="popup-close-button" onClick={toggleUserManagementPopup}>
                ✕
              </button>
              <div className="admin-table-section">
                <h2 className="section-title">
                  User Management ({users.length} users)
                </h2>
                {loading && (
                  <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p>Loading users...</p>
                  </div>
                )}
                
                {!loading && users.length === 0 && (
                  <div className="empty-state">
                    <FaUsers style={{ fontSize: '48px', marginBottom: '20px', opacity: 0.5 }} />
                    <h3>No users found</h3>
                    <p>Add your first user using the form above.</p>
                  </div>
                )}
                
                
                {!loading && users.length > 0 && (
                  <div className="table-container">
                    <table className="users-table">
                      <thead>
                        <tr>
                          <th>Email</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Role</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {users.map(user => (
                          <tr key={user.email}>
                            <td>{user.email}</td>
                            <td>
                              {editingUser === user.email ? (
                                <input
                                  type="text"
                                  value={editingUserData.firstName}
                                  onChange={(e) => handleEditInputChange('firstName', e.target.value)}
                                  className="inline-input"
                                  placeholder="First Name"
                                />
                              ) : (
                                user.firstName || 'N/A'
                              )}
                            </td>
                            <td>
                              {editingUser === user.email ? (
                                <input
                                  type="text"
                                  value={editingUserData.lastName}
                                  onChange={(e) => handleEditInputChange('lastName', e.target.value)}
                                  className="inline-input"
                                  placeholder="Last Name"
                                />
                              ) : (
                                user.lastName || 'N/A'
                              )}
                            </td>
                            <td>
                              {editingUser === user.email ? (
                                <select
                                  value={editingUserData.role}
                                  onChange={(e) => handleEditInputChange('role', e.target.value)}
                                  className="inline-select"
                                >
                                  {roleOptions.map(role => (
                                    <option key={role.value} value={role.value}>
                                      {role.label}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <span className={`role-badge role-${user.role}`}>
                                  {getRoleLabel(user.role)}
                                </span>
                              )}
                            </td>
                            <td>
                              <div className="action-buttons">
                                {editingUser === user.email ? (
                                  <>
                                    <button
                                      onClick={() => saveUserEdit(user.email)}
                                      className="action-button save-button"
                                      title="Save changes"
                                    >
                                      ✓
                                    </button>
                                    <button
                                      onClick={cancelEdit}
                                      className="action-button cancel-button"
                                      title="Cancel edit"
                                    >
                                      ✕
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      onClick={() => startEditUser(user)}
                                      className="action-button edit-button"
                                      title="Edit user"
                                    >
                                      <FaEdit />
                                    </button>
                                    <button
                                      onClick={() => deleteUser(user.email)}
                                      className="action-button delete-button"
                                      title="Delete user"
                                    >
                                      <FaTrash />
                                    </button>
                                  </>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* User Statistics */}
        {users.length > 0 && (
          <div className="admin-form-section" style={{ background: 'rgba(255, 255, 255, 0.05)', marginBottom: '20px' }}>
            <h3 className="section-title">
              <FaUser className="section-icon" />
              User Statistics
            </h3>
            <div className="role-grid">
              {Object.entries(userStats).map(([role, count]) => (
                <div key={role} className="role-item">
                  <span className={`role-badge role-${role}`}>{role}</span>
                  <span className="role-description">{count} user{count !== 1 ? 's' : ''}</span>
                </div>
              ))}
            </div>
          </div>
        )}



        {/* Role Information */}
        <div className="role-info-section">
          <h3 className="section-title-role">Role Descriptions</h3>
          <div className="role-grid">
            {roleOptions.map(role => (
              <div key={role.value} className="role-item">
                <span className="role-code">{role.value}:</span>
                <span className="role-description">{role.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />

    </div>
  );
};

export default AdminDashboard;